<div class="outside-address" *ngIf="address">
  <div class="address-wrapper" [ngClass]="{'hover-primary-border-color': selectable, 'selectable': selectable, 'lightest-accent-background': selected, 'accent-border-color': selected, selected: selected, 'light-primary-border-color': !selected }">
    <div class="address-body">
      <div class="row">
        <div class="col-12">
          <div class="address light-primary-border-color" (click)="select()">
            <div class="name" *ngIf="header">{{header}}</div>
            <div class="name">{{address.firstname}} {{address.lastname}}</div>
            <div class="addr1">{{address.addr1}}</div>
            <div class="addr2" *ngIf="address.addr2">{{address.addr2}}</div>
            <div class="region">{{address.city}}, {{address.state}} {{address.zip}}</div>
            <div class="country">{{address.country ? address.country.title : address.country_iso}}</div>
            <div class="company" *ngIf="address.company">Company: {{address.company}}</div>
            <!-- <br *ngIf="!address.company"> -->
              <div class="phone" *ngIf="address.phone">Phone: {{address.phone}}</div>
            <!-- <br *ngIf="!address.phone"> -->
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="row actions" *ngIf="!deleting && !review">
            <div class="action col-4" *ngIf="selectable" (click)="select()"><a [routerLink]="">{{ selected ? 'Selected' : 'Select' }}</a></div>
            <div class="action col-4" *ngIf="selectable || editable" (click)="edit()"><a [routerLink]="">Edit</a></div>
            <div class="action col-4" (click)="deleting = true"><a [routerLink]="" class="warn">Remove</a></div>
          </div>

          <div class="row actions" *ngIf="deleting && !review">
            <div class="action col-4"><a [routerLink]="">Remove?</a></div>
            <div class="action col-4" (click)="delete()"><a [routerLink]="" class="warn">Yes</a></div>
            <div class="action col-4" (click)="deleting = false"><a [routerLink]="">No</a></div>
          </div>


          <div class="row actions" *ngIf="review">
            <div class="action col-4" (click)="goBack()"><a [routerLink]="">Edit</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>